import React, { useEffect, useState } from "react";
import removeImg from "assets/svgs/close.svg";
import { v4 } from "uuid";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useFieldArray } from "react-hook-form";
import ImageUpload from "components/shared/ImageUpload";
import { handleImage } from "helpers/functions";

const FeaturesArray = ({ control, register, errors }) => {
  const { fields, remove, append, update } = useFieldArray({
    control,
    name: "banner",
  });

  return (
    <div className="form-group branches features">
      <h5>
        <FormattedMessage id={"banner"} />
        {/* <button
          type="button"
          className="btn btn-green"
          onClick={() => {
            append({});
          }}
        >
          <FormattedMessage id={"addInstaImage"} />
        </button> */}
      </h5>
      <Row>
        {fields.map((item, index) => (
          <Item
            item={item}
            remove={() => remove(index)}
            register={register}
            errors={errors}
            key={index}
            index={index}
            update={update}
          />
        ))}
      </Row>
    </div>
  );
};

const Item = ({ item, remove, register, errors, index, update }) => {
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  useEffect(() => {
    setSelectedImage({
      preview: null,
      path: handleImage(item?.image),
    });
  }, []);
  useEffect(() => {
    update(index, {
      ...item,
      image: `/uploads/${selectedImage?.path?.split("/").at(-1)}`,
    });
  }, [selectedImage]);

  const [selectedBack, setSelectedBack] = useState({
    preview: null,
    path: "",
  });

  useEffect(() => {
    setSelectedBack({
      preview: null,
      path: handleImage(item?.background),
    });
  }, []);
  useEffect(() => {
    update(index, {
      ...item,
      background: `/uploads/${selectedBack?.path?.split("/").at(-1)}`,
    });
  }, [selectedBack]);
  const [selectedFile, setSelectedFile] = useState({
    preview: null,
    path: "",
  });

  useEffect(() => {
    setSelectedFile({
      preview: null,
      path: handleImage(item?.file),
    });
  }, []);
  useEffect(() => {
    update(index, {
      ...item,
      file: `/uploads/${selectedFile?.path?.split("/").at(-1)}`,
    });
  }, [selectedFile]);

  return (
    <Col xs={12}>
      <div key={item?.id} className="add-multi-component">
        <button type="button" onClick={remove} className="removeImg">
          <img src={removeImg} alt="" />
        </button>
        <Row>
          <Col xs={6}>
            <div className="form-group required">
              <h5>
                <FormattedMessage id={"background"} />
              </h5>
              <ImageUpload
                selectedImage={selectedBack}
                setSelectedImage={setSelectedBack}
              />
            </div>
          </Col>
          <Col xs={6}>
            <div className="form-group required">
              <h5>
                <FormattedMessage id={"icon"} />
              </h5>
              <ImageUpload
                selectedImage={selectedImage}
                setSelectedImage={setSelectedImage}
              />
            </div>
          </Col>
          <Col xs={6}>
            <div className="form-group required">
              <h5>
                <FormattedMessage id={"file"} />
              </h5>
              <ImageUpload
                accept="application/*"
                selectedImage={selectedFile}
                setSelectedImage={setSelectedFile}
              />
            </div>
          </Col>

          <Col lg={12} xs={12}>
            <div className="form-group">
              <h5>
                <FormattedMessage id={"title"} /> (
                <FormattedMessage id={"arabic"} />)
              </h5>
              <input
                className="form-control form-outline"
                {...register(`banner.${index}.title.ar`, {
                  required: true,
                })}
              />
              <p className="error-hint">
                {errors?.banner?.[index]?.["title"]?.ar?.type ===
                  "required" && <FormattedMessage id={"requiredField"} />}
              </p>
            </div>
          </Col>

          <Col lg={12} xs={12}>
            <div className="form-group">
              <h5>
                <FormattedMessage id={"title"} /> (
                <FormattedMessage id={"english"} />)
              </h5>
              <input
                className="form-control form-outline"
                {...register(`banner.${index}.title.en`, {
                  required: true,
                })}
              />
              <p className="error-hint">
                {errors?.banner?.[index]?.["title"]?.en?.type ===
                  "required" && <FormattedMessage id={"requiredField"} />}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default FeaturesArray;
